import { displayErrorMessage, initializeDataTableServer } from "./common";

window.sfDocumentReady(['route-users'], () => {
  window.setupDatatable('.js-datatable', 'asc');

  const userTable = initializeDataTableServer(
    $('#users-table'),
    '/users',
    [
      { data: 'name' },
      { data: 'type_of_user' },
      { data: 'email' },
      { data: 'mobile' },
      { data: 'last_login' },
      { data: 'actions' }
    ],
    [
      {
        targets: 5,
        className: 'whitespace-nowrap'
      },
    ]
  );

  $('#sort_filter_user').on('submit', function (e) {
    e.preventDefault();
    var formData = $(this).serialize();
    const url = '/users?' + formData;
    userTable.ajax.url(url).load();
  });

  $(document).on('click', '.js-confirm-delete', e => {
    return confirm('Are you sure you want to delete this user?');
  });

  $(document).on('click', '.js-switch-user-login', function (e) {
    e.preventDefault();
    if (!confirm('Are you sure you want to login on behalf of this user?')) {
      return false;
    }
    const data = {
      switch_id: $(this).attr('data-id')
    };

    window.httpPost('/users/userSwitch', data, {
      success(val) {
        if (val.status === 'success') {
          window.location.href = '/';
        } else {
          alert(val.error);
        }
      }
    });
  });
});

window.sfDocumentReady(['route-users-create', 'route-users-edit'], () => {
  $('.js-user-form').submit(function (e) {
    e.preventDefault();
    const data = $(this).serialize();
    window.httpPost('/users/save', data, {
      success: () => notifyBox('Saved', 'User details saved', 'success'),
      error(response, status, error) {
        if (ajaxErrorHandler(response.status)) return;

        $('.js-display-errors').html('');
        $.each(response.responseJSON.errors, (index, value) => {
          $(`#${index}-err`).html(value[0]);
          $(`*[name=${index}]`).addClass('has-error');
        });
      }
    });
  });

  $('.js-supplier-dropdown').select2({
    width: '100%',
    matcher: createSelect2CharactersMatcher()
  });

  toggleVisibility('user_group', getFieldValue('user_group'));
  $('[name="user_group"]').on('change', () =>
    toggleVisibility('user_group', getFieldValue('user_group'))
  );
});

window.sfDocumentReady(['route-profile'], () => {
  $('.js-profile-form').submit(function (e) {
    e.preventDefault();

    const data = $(this).serialize();
    window.httpPost('/profile', data, {
      success(response) {
        $('.js-display-errors').html('');
        notifyBox(response.status, response.message, response.status);
      },
      error(response, status, error) {
        if (response.responseJSON && response.responseJSON.errors) {
          const errors = response.responseJSON.errors;
          displayErrorMessage($('.js-profile-form'), errors)
        } else {
          notifyBox('Error', 'An unexpected error occurred. Please try again', 'error');
        }
        return;
      }
    });
  });
});

const getFieldValue = (name) => $(`[name="${name}"]`).val();
